import { Select } from 'antd';
import { FilterOperatorEnum } from 'domains/appDomain';
import { useTranslation } from 'react-i18next';

type Props = {
  onChange?: (val: string) => void;
  operatorOptions: FilterOperatorEnum[];
};

export const FilterOperatorSelect = ({ operatorOptions, ...props }: Props) => {
  const { t } = useTranslation();
  const operatorDisplayMap: { [index: string]: string } = {
    ANY: t('platform.filter.operator.any'),
    BETWEENS: t('platform.filter.operator.betweens'),
    CONTAINS: t('platform.filter.operator.contains'),
    EQUALS: t('platform.filter.operator.equals'),
    EXISTS: t('platform.filter.operator.exists'),
    GREATER_THAN: t('platform.filter.operator.greater_than'),
    GREATER_THAN_OR_EQUAL: t('platform.filter.operator.greater_than_or_equal'),
    IN: t('platform.filter.operator.in'),
    LESS_THAN: t('platform.filter.operator.less_than'),
    LESS_THAN_OR_EQUAL: t('platform.filter.operator.less_than_or_equal'),
    NOT_EQUALS: t('platform.filter.operator.not_equals'),
    NOT_EXISTS: t('platform.filter.operator.not_exists'),
    NOT_IN: t('platform.filter.operator.not_in'),
    STARTS_WITH: t('platform.filter.operator.starts_with'),
  };
  return (
    <Select
      style={{ width: 130 }}
      defaultValue={FilterOperatorEnum.EQUALS}
      getPopupContainer={(e) => {
        return e as HTMLElement;
      }}
      {...props}
    >
      {operatorOptions.map((operatorOption: string) => {
        return (
          <Select.Option value={operatorOption} key={operatorOption}>
            {operatorDisplayMap[operatorOption]}
          </Select.Option>
        );
      })}
    </Select>
  );
};
